import React, { Component } from "react";
import { Redirect, withRouter } from "react-router-dom";
import compose from "recompose/compose";
import {
  Button,
  Row,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Input,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import RadarChart from "./../../components/RadarChart";
import Api from "../../services/api";
import {
  changeIndexToNepali,
  changeNepaliIndexToEnglish,
  colorScale,
} from "../../utils";
import { connect } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import localMapJson from "../../assets/geoJson/local.json";
import GradientLabel from "../../components/GradientLabel";
import * as modalAction from "../../actions/modalAction";
import MainLoader from "../../components/MainLoader";
import DetailTable from "../../components/Table/DetailTable";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";

// Demo styles, see 'Styles' section below for some notes on use.
import "react-accessible-accordion/dist/fancy-example.css";
import "./style.css";
import ReactExport from "react-export-excel";
import { Helmet } from "react-helmet";
import html2canvas from "html2canvas";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ComposedChart,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import Select from "react-select";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const colors = [
  "#00ff00",
  "#FF0000",
  "#008000",
  "#FFA500",
  "#800080",
  "#A52A2A",
];

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lg: {},
      data: {
        categories: [],
        geoJson: null,
        confirmModal: false,
      },
      isApproved: false,
      showDocModal: false,
      documents: [],
      isLoading: true,
      total: 0,
      mainCategories: [],
      subCategories: [],
      newData: [],
      fiscalYear: [],
      currentFiscalYear: "",
      localData: [],
      activeTab: 0,
      checkIn: [],
      palikaData: null,
      palikaOptions: [],
      comparision: [],
      selectedValues: [],
      selectedOptions: [],
      charData: null,
      compareData: [],
      finalData: [],
      dataKeys: [],
      gnid: null,
    };
    this._renderCategoriesList = this._renderCategoriesList.bind(this);
    this.toggle = this.toggle.bind(this);
    this._getTotalScore = this._getTotalScore.bind(this);
    this._getTotalMarks = this._getTotalMarks.bind(this);
    this._getFiscalyear = this._getFiscalyear.bind(this);
    // this._verifyForm = this._verifyForm.bind(this);
    this._getPalika = this._getPalika.bind(this);
    this._getCompareData = this._getCompareData.bind(this);
    this._getAllPublishedPalika = this._getAllPublishedPalika.bind(this);
    this._getLocalAPI = this._getLocalAPI.bind(this);
    this.printRef = React.createRef();
    this.printRankingRef = React.createRef();
  }
  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  _handleInitialFetching = async () => {
    let { subCategories, lg } = this.state;
    const { user } = this.props;
    const { type, id } = this.props.match.params;
    let data, isApproved;
    let geoJson = localMapJson.response.filter((palika) => {
      return id === palika.gnid;
    });
    geoJson = geoJson[0];
    lg = geoJson;
    try {
      data = await Api.getIndividualDashboard({
        fiscal_year_id: this.state.currentFiscalYear,
        gnid: id,
      });
      console.log("dataI", data);
      isApproved = data.response.status >= 4;
    } catch (e) {
      isApproved = false;
    }
    if (isApproved) {
      let modifiedData = [];
      let totalGlobal = 0;
      let obtainedGlobal = 0;
      let totalMarks = 0;

      data.response.detail.map((cat) => {
        let totalMarks = parseFloat(cat.marks);
        let obtainedMarks = parseFloat(cat.score);
        let average = parseFloat(cat.average);
        modifiedData.push({
          question: cat.category,
          marks: totalMarks,
          score: obtainedMarks,
          average: average,
          percentage: cat.percentage,
          image: cat.image,
          isCat: true,
          isMainCat: true,
        });
        totalGlobal += totalMarks;
        obtainedGlobal += obtainedMarks;
        let sortedQn = cat.questions.sort(
          (a, b) =>
            parseFloat(changeNepaliIndexToEnglish(a.indicator)) -
            parseFloat(changeNepaliIndexToEnglish(b.indicator))
        );
        cat.questions.map((qn) => {
          modifiedData.push(qn);
        });

        //set total subcategory score
        cat.subCategories.map((subCategory) => {
          if (subCategories[subCategory.name]) {
            subCategories[subCategory.name] = {
              name: subCategory.name,
              marks:
                subCategories[subCategory.name].marks +
                parseFloat(subCategory.marks),
              score:
                subCategories[subCategory.name].score +
                parseFloat(subCategory.score),
            };
          } else {
            subCategories[subCategory.name] = {
              name: subCategory.name,
              marks: parseFloat(subCategory.marks),
              score: parseFloat(subCategory.score),
            };
          }
        });
      });
      let subCategoriesIndexArray = Object.keys(subCategories).map(
        (sCatKey) => subCategories[sCatKey]
      );
      subCategoriesIndexArray.map((sCat) => {
        sCat.percentage = ((sCat.score / sCat.marks) * 100).toFixed(2);
      });

      modifiedData.splice(0, 0, {
        question: "जम्मा",
        marks: totalGlobal,
        score: obtainedGlobal,
        isCat: true,
      });

      let columns = this._getColumns(modifiedData);
      let total = modifiedData[0];
      let mainCategories = modifiedData.filter((data) => {
        return !!data.isMainCat;
      });
      this.setState({
        data: modifiedData,
        geoJson: geoJson.geometry,
        columns: columns,
        isLoading: false,
        total,
        mainCategories,
        detailCatData: data.response.detail,
        subCategories: subCategoriesIndexArray,
        lg,
        isApproved,
        newData: data.response.detail,
      });
    } else {
      this.setState({
        // data: modifiedData,
        geoJson: geoJson.geometry,
        // columns: columns,
        isApproved: isApproved,
        isLoading: false,
        lg,
      });
    }
  };
  _getLocalAPI = async () => {
    const { checkIn } = this.state;
    const fiscal_year_id = localStorage.getItem("fiscalYear");
    console.log("fiscal_year_id", localStorage.getItem("fiscalYear"));
    let isApproved;
    const { type, id } = this.props.match.params;
    let geoJson = localMapJson.response.filter((palika) => {
      return id === palika.gnid;
    });
    geoJson = geoJson[0];
    try {
      const localData = await Api.getLocalDataAPI(fiscal_year_id, id);
      this.setState({ localData });
      checkIn.push({
        ...(localData.response.ranking_indexes &&
          localData.response.ranking_indexes.local_level),
        name: `(Local Level) ${localData.response.ranking_indexes &&
          localData.response.ranking_indexes.local_level &&
          localData.response.ranking_indexes.local_level.name}`,
      });
      checkIn.push({
        ...(localData.response.ranking_indexes &&
          localData.response.ranking_indexes.district_level),
        name: `(District Leader) ${localData.response.ranking_indexes &&
          localData.response.ranking_indexes.district_level &&
          localData.response.ranking_indexes.district_level.name}`,
      });
      checkIn.push({
        ...(localData.response.ranking_indexes &&
          localData.response.ranking_indexes.province_level),
        name: `(Province Leader) ${localData.response.ranking_indexes &&
          localData.response.ranking_indexes.province_level &&
          localData.response.ranking_indexes.province_level.name}`,
      });
      checkIn.push({
        ...(localData.response.ranking_indexes &&
          localData.response.ranking_indexes.nepal_level),
        name: `(Nepal) ${localData.response.ranking_indexes &&
          localData.response.ranking_indexes.nepal_level &&
          localData.response.ranking_indexes.nepal_level.name}`,
      });
      console.log("checkIn", checkIn);
    } catch (e) {
      isApproved = false;
    }
  };

  async componentDidMount() {
    const fiscal_year_id = this.props.fiscal_year_id;
    let gnid;
    let urlgnid = window.location.href.split("/");
    let id = urlgnid[urlgnid.length - 1];
    let fiscal = localStorage && localStorage.getItem("fiscalYear");
    localStorage.gnid
      ? (gnid = JSON.parse(localStorage && localStorage.user).user.gnid)
      : (gnid = id);
    this._getFiscalyear();
    await this.setState({
      currentFiscalYear: fiscal_year_id ? fiscal_year_id : fiscal,
      gnid: gnid,
    });
    this._handleInitialFetching();
    this._getLocalAPI();
    this._getPalika();
    this._getAllPublishedPalika();
    this._getCompareData();
  }

  _getFiscalyear = async () => {
    let fyList = await Api.getFyList();
    this.setState({ fiscalYear: fyList.response });
  };
  _getCompareData = async (selectedOptions) => {
    const { currentFiscalYear, gnid } = this.state;
    let compareData = await Api.comparePalikas({
      fiscal_year_id: currentFiscalYear,
      gnid: selectedOptions ? selectedOptions.map((d) => d.value) : gnid,
    });
    this.setState({
      compareData: compareData.response,
    });
    const others = this.state.compareData.map((item) => {
      const name = Object.keys(item)[0];
      const data = item[name];
      return {
        ...data,
      };
    });
    const dataKeys =
      (others &&
        others[0] &&
        Object &&
        Object.keys &&
        Object.keys(others[0])) ||
      [];

    this.setState({
      nepalData: compareData.response.nepal,
      dataKeys: dataKeys,
      finalData: others,
    });
  };

  _getPalika = async () => {
    let palika = await Api.getAllPalikaMap();
    // console.log("palikaData", palika.response);
    this.setState({ palikaData: palika.response });
  };

  // initialcomparisionchange

  handleChange = (selectedOptions) => {
    const { currentFiscalYear } = this.state;
    const getCompareData = async () => {
      let compareData = await Api.comparePalikas({
        fiscal_year_id: currentFiscalYear,
        gnid: selectedOptions.map((d) => d.value),
      });

      this.setState({
        selectedOptions,
        compareData: compareData.response,
      });
      // console.log("compareData", compareData.response);

      const others = this.state.compareData.map((item) => {
        const name = Object.keys(item)[0];
        const data = item[name];
        return {
          name,
          ...data,
        };
      });
      console.log("others", others);
      const dataKeys = Object.keys(others[0]).filter((key) => key !== "name");

      this.setState({
        dataKeys: dataKeys,
        finalData: others,
      });
    };

    getCompareData();
  };
  _getAllPublishedPalika = async () => {
    let publishedPalika = await Api.getAllPublishedPalika(
      this.state.currentFiscalYear
    );
    if (publishedPalika && publishedPalika.response) {
      const palikaOptions = publishedPalika.response.map((item) => ({
        value: item.gnid,
        label: `${item.name}`,
      }));
      this.setState({ palikaOptions });
    }
  };

  _renderCategoriesList() {
    const { mainCategories } = this.state;
    return mainCategories.map((category, catIndex) => {
      return (
        <div>
          <div className="main-list" key={catIndex}>
            <span className="dash-cat-name">
              <img src={category.image} className="cat-icon" alt="cat-icon" />
              {category.question}
            </span>
            {/* <span className='dash-cat-rank'>{changeIndexToNepali(category.rank)}</span> */}
            <span
              className="dash-cat-score"
              style={{
                color: "white",
                background: colorScale(category.percentage),
              }}
            >
              {changeIndexToNepali(category.percentage)}%
            </span>
          </div>
        </div>
      );
    });
  }

  _getColumns = (data) => {
    // sn., title, total_mark, obtained_mark , remarks
    //      question, total_mark, obtained_mark, remarks

    let columns = [
      {
        Header: "क्र.सं.",
        id: "id",
        maxWidth: 50,
        Cell: (row) => {
          return changeIndexToNepali(row.index + 1);
        },
      },
      {
        id: "title",
        Header: "सूचक",
        maxWidth: 1000,
        accessor: (d) => {
          if (d.isCat) {
            return <b>{d.question}</b>;
          } else {
            return d.question;
          }
        },
      },
      {
        id: "marks",
        Header: "पूर्णाङ्क",
        maxWidth: 150,
        accessor: (d) => {
          return changeIndexToNepali(d.marks);
        },
      },
      {
        id: "score",
        Header: "प्राप्ताङ्क",
        maxWidth: 150,
        accessor: (d) => {
          return changeIndexToNepali(d.score);
        },
      },
      {
        id: "remarks",
        Header: "कैैफियत",
        maxWidth: 200,
        accessor: (d) => {
          return changeIndexToNepali(d.remarks);
        },
      },
    ];
    return columns;
  };

  toggle() {
    this.setState({
      confirmModal: !this.state.confirmModal,
    });
  }

  _verifyForm = async () => {
    const { type, id } = this.props.match.params;
    const { user } = this.props;
    this.toggle();
    let response = await Api.verifyForm({
      fiscal_year_id: user.fiscal_year_id,
      gnid: id,
    });
    toast.success(response.status, {
      position: toast.POSITION.TOP_CENTER,
    });
  };

  _verifyForm = async () => {
    const { type, id } = this.props.match.params;
    this.toggle();
    let response = await Api.verifyForm({
      fiscal_year_id: this.state.currentFiscalYear,
      gnid: id,
    });
    toast.success(response.status, {
      position: toast.POSITION.TOP_CENTER,
    });
  };

  _onFormClick = () => {
    return (
      <Redirect
        to={{
          pathname: "/selfaccessmentform",
          state: { from: this.props.location },
        }}
      />
    );
  };

  _openDocumentModal = () => {
    const { onDocumentsShow } = this.props;
    const { id } = this.props.match.params;
    onDocumentsShow({ gnid: id, modalType: "view" });
  };
  _getTotalScore = (data) => {
    let numbers = [];
    data.map((item) => numbers.push(parseFloat(item.score)));
    return numbers.reduce((a, b) => a + b, 0);
  };
  _getTotalMarks = (data) => {
    let numbers = [];
    data.map((item) => numbers.push(parseFloat(item.marks)));
    return numbers.reduce((a, b) => a + b, 0);
  };

  _import2Excel = () => {
    const { data, columns } = this.state;
    let filteredData = this._getFilteredData();
    let excelColumns = [
      <ExcelColumn key="question" label="सूचक" value="question" />,
      <ExcelColumn key="marks" label="पूर्णाङ्क" value="marks" />,
      <ExcelColumn key="score" label="प्राप्ताङ्क" value="score" />,
      <ExcelColumn key="remarks" label="कैैफियत" value="remarks" />,
    ];
    return (
      <ExcelFile
        element={
          <Button color="primary" style={{ marginRight: 10 }}>
            डाउनलोड
          </Button>
        }
      >
        <ExcelSheet data={filteredData} name="स्थानीय तह स्थिति टेबल">
          {excelColumns}
        </ExcelSheet>
      </ExcelFile>
    );
  };

  _getFilteredData = () => {
    const { data, searchInput } = this.state;
    const searchKeys = ["question", "marks", "score", "remarks"];
    if (searchInput) {
      let filteredData = data.filter((d) => {
        let found = false;
        searchKeys.map((searchKey) => {
          if (d[searchKey].toString().includes(searchInput)) found = true;
        });
        return found;
      });
      return filteredData;
    }
    return data;
  };

  _handleDownloadImage = async () => {
    const element = this.printRef.current;
    const canvas = await html2canvas(element);

    const data = canvas.toDataURL("image/jpg");
    const link = document.createElement("a");

    if (typeof link.download === "string") {
      link.href = data;
      link.download = "RadarChart.jpg";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      window.open(data);
    }
  };
  _handleDownloadRankingImage = async () => {
    const element = this.printRankingRef.current;
    const canvas = await html2canvas(element);

    const data = canvas.toDataURL("image/jpg");
    const link = document.createElement("a");

    if (typeof link.download === "string") {
      link.href = data;
      link.download = "RadarChart.jpg";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      window.open(data);
    }
  };

  _handleFiscalYearChange = async (e) => {
    let fiscalYearId = e.target.value;
    await this.setState({
      currentFiscalYear: fiscalYearId,
      isLoading: true,
    });
    localStorage.setItem("fiscalYear", fiscalYearId);
    await this._handleInitialFetching();
    this.setState({
      isLoading: false,
    });
  };

  _renderDashboard = () => {
    const {
      currentFiscalYear,
      fiscalYear,
      newData,
      data,
      showDocModal,
      documents,
      isApproved,
      isLoading,
      checkIn,
      mainCategories,
      detailCatData,
      lg,
      palikaOptions,
      selectedOptions,
      finalData,
      dataKeys,
    } = this.state;
    if (isLoading) {
      return <div>Loading...</div>;
    }
    if (!isApproved) {
      return (
        <>
          <div className="header">
            <h1 className="heading">{lg.name}</h1>{" "}
            {/*TODO show , district name from map data*/}
            <div className="d-flex align-items-center">
              <div className="mt-2">
                <Input
                  className=""
                  type="select"
                  name="fselect"
                  id="fiscalYearSelect"
                  value={currentFiscalYear}
                  onChange={(e) => this._handleFiscalYearChange(e)}
                >
                  <option value={0} disabled selected>
                    आर्थिक वर्ष चयन गार्नुहोस
                  </option>
                  {fiscalYear.length > 0 &&
                    fiscalYear.map((fy, index) => {
                      return (
                        <option key={fy.id} value={fy.id}>
                          आर्थिक वर्ष {fy.name}
                        </option>
                      );
                    })}
                </Input>
              </div>
            </div>
          </div>
          <div>फारम सार्वजनिक भएको छैन।</div>
        </>
      );
    }
    return (
      <>
        <Helmet>
          <title>GESI Nepal - Details</title>
        </Helmet>
        <div>
          <div className="header">
            <h1 className="heading">{lg.name}</h1>{" "}
            {/*TODO show , district name from map data*/}
            <div className="d-flex align-items-center">
              <div className="mt-2 mr-4">
                <Input
                  className=""
                  type="select"
                  name="fselect"
                  id="fiscalYearSelect"
                  value={currentFiscalYear}
                  onChange={(e) => this._handleFiscalYearChange(e)}
                >
                  <option value={0} disabled selected>
                    आर्थिक वर्ष चयन गार्नुहोस
                  </option>
                  {fiscalYear.length > 0 &&
                    fiscalYear.map((fy, index) => {
                      return (
                        <option key={fy.id} value={fy.id}>
                          आर्थिक वर्ष {fy.name}
                        </option>
                      );
                    })}
                </Input>
              </div>
              <GradientLabel />
            </div>
          </div>

          <div className="content">
            {/* <Row>
              <Col sm="9">
                <div className="card-layout">
                  <h3 className="sub-heading">जम्मा प्राप्ताङ्क</h3>
                  <div className="progress-section">
                    <Row>
                      <Col sm="2">
                        <h3 className="green-number" style={{ color: colorScale(total.score) }}>{changeIndexToNepali(total.score)}%</h3>
                        <p>औसत</p>
                      </Col>
                      <Col sm="10">
                        <div className="progress-box">
                          {subCategories.map((sCat, sIndex) => {
                            return (
                              <Row key={sIndex}>
                                <Col sm="4">
                                  <h3 className="progressbar-text">{sCat.name}</h3>
                                </Col>
                                <Col sm="8">
                                  <div style={{ marginLeft: `${sCat.score}%` }} className="progress-percent">{changeIndexToNepali(sCat.percentage)}%</div>
                                  <Line percent={sCat.percentage} strokeWidth={1} strokeColor={colorScale(sCat.percentage)} />
                                </Col>
                              </Row>
                            );
                          })}
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div className="ranking-section">
                              <Row>
                                  <Col sm="2">
                                      <h3 className="red-number">{changeIndexToNepali(data.rank)} / {changeIndexToNepali(data.total)}</h3>
                                      <p>बरीयतक्रम </p>
                                  </Col>
                                  <Col sm="8">
                                      <div className="ranking-timeline">
                                          <span className="vertical-line"></span>
                                          <span className="circle" style={{ marginLeft: "100px" }}>{changeIndexToNepali(data.rank-3)}  <label>{data.rankNeighbours.prev3.name}</label></span>
                                          <span className="circle" style={{ marginLeft: "200px" }}>{changeIndexToNepali(data.rank-2)} <label>{data.rankNeighbours.prev2.name}</label></span>
                                          <span className="circle" style={{ marginLeft: "300px" }}>{changeIndexToNepali(data.rank-1)} <label>{data.rankNeighbours.prev1.name} </label> </span>
                                          <span className="circle-active" style={{ marginLeft: "400px" }}>{changeIndexToNepali(data.rank)} <label>{data.name} </label></span>
                                          <span className="circle" style={{ marginLeft: "500px" }}>{changeIndexToNepali(data.rank+1)} <label>{data.rankNeighbours.next1.name}  </label></span>
                                          <span className="circle" style={{ marginLeft: "600px" }}>{changeIndexToNepali(data.rank+2)} <label>{data.rankNeighbours.next2.name}  </label></span>
                                          <span className="circle" style={{ marginLeft: "700px" }}>{changeIndexToNepali(data.rank+3)} <label>{data.rankNeighbours.next3.name} </label></span>

                                      </div>
                                  </Col>
                              </Row>
                          </div>

              </Col>
              <Col sm="3">
                <div className="card-layout">
                  <h3 className="sub-heading2">गृहपृष्ठ </h3>
                  <div className="leaflet-container">
                    <Map geoJson={geoJson} />
                  </div>
                  <p className="location">{data.name}</p>
                </div>
              </Col>
            </Row> */}

            <div className="chart-section">
              <Row>
                <Col sm="4">
                  <div className="cat-list card-layout">
                    <div className="d-flex justify-content-between">
                      <h3 className="sub-heading">
                        {" "}
                        स्व-मूल्याङ्कन विषयक्षेत्रहरु{" "}
                      </h3>
                      <h3 style={{ color: "#F6961D" }}>
                        {changeIndexToNepali(data[0].score)}%
                      </h3>
                    </div>

                    <div className="main-list">
                      <span className="dash-cat-name-title"></span>
                      {/* <span className='dash-cat-rank-title'>बरीयतक्रम</span> */}
                      <span className="dash-cat-score-title">
                        स्कोर प्रतिशत
                      </span>
                    </div>
                    {this._renderCategoriesList()}
                  </div>
                </Col>
                <Col sm="8">
                  <div className="card-layout">
                    <div className="d-flex justify-content-end">
                      <button
                        type="button"
                        className="btn btn-primary btn-sm"
                        onClick={this._handleDownloadImage}
                      >
                        डाउनलोड
                      </button>
                    </div>

                    <div ref={this.printRef}>
                      <RadarChart
                        width={800}
                        height={500}
                        data={mainCategories}
                      />
                      {console.log("mainCategories", mainCategories)}
                    </div>
                  </div>
                </Col>
              </Row>
            </div>

            {/* <div className="bar-chart">
              <Row>
                <Col sm="12">
                  <div className="bar-chart">
                    <Row>
                      <Col sm="12">
                        <div className="card-layout bar-graph">
                          <BarGraph data={mainCategories} />
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </div> */}
            <div className="card-layout mt-4">
              <div className="d-flex justify-content-between py-4">
                <h4 className="sub-heading">
                  लैङ्गिक समानता र सामाजिक समावेशीकरण अंक तालिका
                </h4>
                <button
                  className="btn btn-primary"
                  onClick={this._handleDownloadRankingImage}
                >
                  डाउनलोड
                </button>
              </div>
              <div ref={this.printRankingRef}>
                <ResponsiveContainer height={500} width="100%">
                  <BarChart layout="vertical" data={checkIn}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis type="number" />
                    <YAxis dataKey="name" type="category" />
                    <Tooltip />
                    <Bar dataKey="score" fill="#8884d8" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
            <div className="data-details d-flex card-layout">
              {/* {detailCatData.map((category, catIndex) => {
                  return (
                    <Col sm="4" key={catIndex}>
                      <div className="details-box card-layout">
                        <div className="data-header">
                          <h3 className="data-name">{category.category}</h3>
                          <div className="rank-score">
                            <div className="score">
                              <h3
                                className="data-score"
                                style={{
                                  color: colorScale(
                                    mainCategories[catIndex].percentage
                                  ),
                                }}
                              >
                                {changeIndexToNepali(
                                  mainCategories[catIndex].percentage
                                )}
                                %
                              </h3>
                              <p> स्कोर प्रतिशत</p>
                            </div>
                          </div>
                        </div>
                        <div className="main-list main-list-header">
                          <span className="dash-cat-name">तहहरु</span>
                          <span className="dash-cat-score-title">स्कोर</span>
                        </div>
                        {category.subCategories.map((sCat, sCatIndex) => (
                          <div>
                            {sCat.score ? (
                              <div className="main-list" key={sCatIndex}>
                                <span className="dash-cat-name">
                                  {sCat.name}
                                </span>
                                <span
                                  className="dash-cat-score"
                                  style={{
                                    color: "white",
                                    background: colorScale(
                                      (sCat.score / sCat.marks) * 100
                                    ),
                                  }}
                                >
                                  {changeIndexToNepali(sCat.score)}
                                </span>
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>
                        ))}
                      </div>
                    </Col>
                  );
                })} */}

              <Col sm="3">
                <h3 className="sub-heading" style={{ marginBottom: "20px" }}>
                  लैससास परीक्षण नतिजा
                </h3>
                {detailCatData.map((data, index) => (
                  <Nav
                    tabs
                    vertical
                    pills
                    style={{ border: "none" }}
                    className="col-12"
                  >
                    <NavItem key={index}>
                      <NavLink
                        className={
                          this.state.activeTab === index ? "active" : ""
                        }
                        onClick={() => {
                          this.toggle(index);
                          this.state.activeTab = index;
                        }}
                      >
                        {data.category}
                      </NavLink>
                    </NavItem>
                  </Nav>
                ))}
              </Col>
              <Col className="">
                <TabContent className="mt-2" activeTab={this.state.activeTab}>
                  {detailCatData.map((data, index) => {
                    if (index === this.state.activeTab) {
                      return (
                        <TabPane key={index} tabId={index}>
                          <h3
                            className="data-score d-flex justify-content-end"
                            style={{
                              color: colorScale(data.percentage),
                              marginRight: "2%",
                            }}
                          >
                            {data.percentage}%
                          </h3>
                          <div className="d-flex flex-wrap">
                            {data.subCategories.map((subData, subIndex) => (
                              <div className="col-6">
                                <div className="main-list" key={subIndex}>
                                  <span className="dash-cat-name">
                                    {subData.name}
                                  </span>
                                  <span
                                    className="dash-cat-score"
                                    style={{
                                      color: "white",
                                      background: colorScale(
                                        (subData.score / subData.marks) * 100
                                      ),
                                    }}
                                  >
                                    {changeIndexToNepali(subData.score)}
                                  </span>
                                </div>
                              </div>
                            ))}
                          </div>
                        </TabPane>
                      );
                    }
                  })}
                </TabContent>
              </Col>

              <Modal
                isOpen={showDocModal}
                toggle={() => this._toggleCatAttatchmentModal()}
                className="delete-modal"
              >
                <ModalHeader>प्रमाणीकरणको आधार</ModalHeader>
                <ModalBody>
                  {documents.map((document) => {
                    return (
                      <a target="_blank" href={document.url} key={document.id}>
                        <p>{document.name}</p>
                      </a>
                    );
                  })}
                </ModalBody>
              </Modal>
            </div>
          </div>
        </div>

        {/* शीर्षकगत प्राप्ताङ्क तालिका */}
        {/* <Row style={{ marginTop: "40px" }}>
          <Col className="table-responsive card-layout mx-3">
            <Row>
              <Col>
                <h5 className="sub-heading">शीर्षकगत प्राप्ताङ्क तालिका</h5>
              </Col>

              <Col className=" d-flex justify-content-end">
                <h5 style={{ color: "#CC9E01" }}>
                  {localData.response.score}%
                </h5>
              </Col>
            </Row>

            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>क्र.स.</th>
                  <th>सूचक र उप-सूचकहरु</th>
                  <th>पूर्णाङ्क</th>
                  <th>कुल प्राप्ताङ्क</th>
                </tr>
              </thead>
              <tbody>
                {console.log("localData", localData)}
                {localData.response.categories.map((local, index) => (
                  <tr>
                    <td>{changeIndexToNepali(index + 1)}</td>
                    <td>{local.range}</td>
                    <td>{local.total_marks}</td>
                    <td>{local.score}</td>
                  </tr>
                ))}
                <tr>
                  <td></td>
                  <td>कुल प्राप्ताङ्क</td>
                  <td>100</td>
                  <td>{localData.response.score}</td>
                </tr>
              </tbody>
            </table>
          </Col>
        </Row> */}
        <div style={{ marginTop: "40px" }}>
          <div className="report-header">
            <h2 className="sub-heading">रिपोर्ट टेबल</h2>
            <div className="report-controls">
              <Button
                onClick={() => this._openDocumentModal()}
                className="btn btn-info mr-2"
              >
                कागजातहरु हेर्नुहोस
              </Button>
              {this._import2Excel()}
            </div>
          </div>

          {/* <Accordion allowZeroExpanded preExpanded={[0]}> */}
          <Accordion allowZeroExpanded>
            {newData.map((item, i) => (
              <AccordionItem uuid={i++}>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <div>{changeIndexToNepali(i) + ". " + item.category}</div>
                    <div>
                      {changeIndexToNepali(item.score)}/
                      {changeIndexToNepali(item.marks)}
                    </div>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <DetailTable comments={item} />
                </AccordionItemPanel>
              </AccordionItem>
            ))}
            <AccordionItem>
              <AccordionItemHeading>
                <AccordionItemButton>
                  <div>कुल</div>
                  <div>
                    {changeIndexToNepali(this._getTotalScore(newData))}/
                    {changeIndexToNepali(this._getTotalMarks(newData))}
                  </div>
                </AccordionItemButton>
              </AccordionItemHeading>
            </AccordionItem>
          </Accordion>
        </div>

        <div className="card-layout">
          {console.log("palikaOptions", palikaOptions)}
          <div className="d-flex justify-content-between py-4">
            {/* <h1 className="heading">तुलना</h1> */}
            <h1 className="sub-heading">तुलनात्मक चार्ट</h1>
            <div>
              <Select
                className="my-select"
                placeholder={<div>पालिका चयन गर्नुहोस्</div>}
                options={palikaOptions}
                isMulti
                defaultValue={palikaOptions.filter(
                  (key) => key.value === this.state.gnid
                )}
                onChange={this.handleChange}
                isOptionDisabled={() => selectedOptions.length >= 5}
              />
            </div>
          </div>

          <ResponsiveContainer width={"100%"} aspect={3}>
            <ComposedChart data={finalData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend iconSize={30} />
              {console.log("dataKeys", dataKeys)}
              {dataKeys &&
                dataKeys
                  .filter((key) => key !== "नेपाल")
                  .map((key, index) => {
                    const color = `#${Math.floor(
                      Math.random() * 16777215
                    ).toString(16)}`;
                    console.log("keys", key);
                    return (
                      <Line
                        strokeWidth={3}
                        key={`${key}-line`}
                        type="monotone"
                        dataKey={key}
                        stroke={colors[index]}
                      />
                    );
                  })}
              <Bar barSize={40} dataKey="नेपाल" fill={"#8784D8"} />
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      </>
    );
    // if(!data && !data.length > 1) {
    //   return (<div>तपाईको फारम स्विक्रित भएको छैन। क्रिपया फारममा भएका सम्पूर्ण जवाफ साथसाथै कागजातहरु अपलोड गर्नुहोस्।</div>);
    // }
  };

  render() {
    const {
      data,
      geoJson,
      confirmModal,
      showDocModal,
      documents,
      columns,
      isApproved,
      isLoading,
    } = this.state;
    return (
      <MainLoader active={isLoading}>
        <section className="dashboard">
          <ToastContainer />

          {this._renderDashboard()}
        </section>
      </MainLoader>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  onDocumentsShow: (modalProps) => {
    dispatch(
      modalAction.processModal(
        modalAction.SHOW_MODAL,
        modalAction.ModalTypes.SHOW_DOCUMENT,
        modalProps
      )
    );
  },
});

const enhance = compose(withRouter, connect(null, mapDispatchToProps));

export default enhance(Dashboard);
